import { planTypes } from '@/common/constants';
import { checkCorporateDomain } from '@/apis/signing';
import ZcmPurchaseBlockedDialog from '@/components/zcm-purchase-blocked-dialog.vue';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';

class ZcmDomainCheckService {
  constructor() {
    this.hasChecked = false;
    this.dialogService = null;
  }

  init(store) {
    this.store = store;
    this.dialogService = new ServiceConfirm(ZcmPurchaseBlockedDialog, store);
    
    store.watch(
      (state, getters) => ({
        cartIsReady: getters.cartIsReady,
        account: getters.account,
        getSelectedPlans: getters.getSelectedPlans,
      }),
      (newVal) => {
        this.tryCheckZcm(newVal);
      },
      { deep: true }
    );
  }

  tryCheckZcm({ cartIsReady, account, getSelectedPlans }) {
    if (this.hasChecked) {
      return;
    }

    if (!window.$context?.is?.loggedIn) {
      return;
    }

    if (!cartIsReady || !account?.email) {
      return;
    }

    const hasZoomComplianceManager = getSelectedPlans.some(plan => 
      plan.type === planTypes.ZCM
    );

    if (!hasZoomComplianceManager) {
      return;
    }

    this.hasChecked = true;
    this.checkDomain(account.email);
  }

  async checkDomain(userEmail) {
    try {
      const response = await checkCorporateDomain(userEmail);
      const shouldBlock = response?.result;
      
      if (shouldBlock) {
        const signInSource = this.store.getters.signInSource;
        
        if (signInSource === 'modal') {
          this.store.dispatch('removePlanByKey', { key: 'ZCM', force: true });
          this.store.commit('setZcmDomainWarning', true);
        } else {
          this.showDialog();
        }
      }
    } catch (error) {
      console.warn('Failed to check corporate domain on page load:', error);
    }
  }

  async showDialog() {
    try {
      await this.dialogService.confirm();
    } catch (error) {
      console.log('Dialog closed');
    } finally {
      this.handleDialogClose();
    }
  }

  handleDialogClose() {
    this.store.dispatch('removePlanByKey', { key: 'ZCM', force: true });
  }
}

const zcmDomainCheckService = new ZcmDomainCheckService();

export default zcmDomainCheckService;
